<template>
  <div class="paddbox autobox">
    <div>
      <el-card>
        <el-form label-width="100px" @submit.prevent>
          <el-form-item label="开发者账户：">
            <el-select v-model="form.developerAccountId" size="small" placeholder="请选择开发者账户" style="width: 100%"
              :loading="devOptionsLoading" @visible-change="loadDevOptions">
              <el-option v-for="item in devOptions" :key="item.id" :label="item.remark" :value="item.id" />
            </el-select>
          </el-form-item>

          <el-form-item label="巨量账户：">
            <el-input v-model="form.accountIdsText" type="textarea" :rows="4" placeholder="每行一个巨量账户id" />
          </el-form-item>

          <el-form-item label="上传图片：">
            <el-upload ref="uploadRef" drag name="imageFile" :auto-upload="false" :limit="1" accept="image/*"
              :headers="{ authorize: token }" :action="uploadAction" :data="uploadData"
              :on-change="handleUploadChange" :on-remove="handleUploadRemove" :on-exceed="handleExceed"
              :on-success="handleUploadSuccess" :on-error="handleUploadError">
              <el-icon class="el-icon--upload">
                <UploadFilled />
              </el-icon>
              <div class="el-upload__text">将文件拖到此处，或 <em>点击上传</em></div>
              <template #tip>
                <div class="el-upload__tip">只支持 bmp/jpeg/jpg/png，图片大小≤5M，像素≤300×300</div>
              </template>
            </el-upload>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" :loading="submitting" @click="submitFun">确定</el-button>
            <el-button @click="cancelFun">取消</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>

    <div>



    </div>

    <!-- 头像更新结果 -->
    <el-dialog title="导入结果" v-model="resultVisible" width="70%" destroy-on-close>
      <div style="margin-bottom: 8px;">
        共 {{ resultSummary.total }} 条，成功 {{ resultSummary.successCount }} 条，失败 {{ resultSummary.failCount }} 条
      </div>
      <el-table :data="resultItems" border style="width: 100%" empty-text="暂无结果"
        :header-cell-style="{ background: '#f5f7fa', color: '#606266' }">
        <el-table-column label="巨量账户" width="180">
          <template #default="scope">{{ scope.row.accountId ?? '-' }}</template>
        </el-table-column>
        <el-table-column label="结果" width="100" align="center">
          <template #default="scope">
            <span :style="{ color: scope.row.success ? '#67c23a' : '#f56c6c' }">
              {{ scope.row.success ? '成功' : '失败' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="消息" min-width="300">
          <template #default="scope">{{ scope.row.message ?? '-' }}</template>
        </el-table-column>
      </el-table>
      <template #footer>
        <el-button size="mini" @click="handleResultClose">关闭</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { juliangDevList } from '@/request/new/juliangDev'
import { juliangDevUpdateAvatar } from '@/request/new/ylyBatch'
import { baseURL } from '@/request/config'
import { ElMessage } from 'element-plus'
import { UploadFilled } from '@element-plus/icons-vue'
import { inject, nextTick, reactive, ref, toRefs, watch } from 'vue'


export default {
  name: 'ylyHeaderImageUpload',
  components: { UploadFilled },
  emits: ['cancel', 'success'],
  setup(props, { emit }) {
    // el-upload 实例（校验不通过时清空文件）
    const uploadRef = ref(null)
    const state = reactive({
      // 表单数据
      form: {
        // 开发者账户id
        developerAccountId: null,
        // 巨量账户：原始 textarea 文本（每行一个）
        accountIdsText: '',
        // 巨量账户：解析后的数组（前后去空格，过滤空行）
        accountIds: [],
        // 上传文件列表
        fileList: [],
      },
      // 开发者下拉选项（点击选择器时加载）
      devOptions: [],
      devOptionsLoading: false,
      // 提交中
      submitting: false,
      // 上传地址统一走 config.js，切换环境自动生效（参考 ylyProductImage 的图片上传方式）
      uploadAction: baseURL + '/r4/juliang-dev/uploadAvatar',
      // 获取用户token
      token: 'Bearer' + localStorage.getItem('token'),
      // 上传时携带的参数（点击确定后赋值为最新值）
      uploadData: {},
      // 第一步上传成功返回的 imageId，及当时使用的参数（参数变了需要重新上传）
      imageId: null,
      uploadedFor: null,
      // 头像更新结果弹窗
      resultVisible: false,
      resultItems: [],
      resultSummary: { total: 0, successCount: 0, failCount: 0 },
      resultAllSuccess: false,
    })

    // 解析 textarea 文本：按行分割、前后去空格、过滤空行
    const parseAccountIds = (text) => {
      return String(text || '')
        .split(/\r?\n/)
        .map((s) => s.trim())
        .filter((s) => s.length > 0)
    }

    // textarea 文本变化时，同步解析后的数组
    watch(
      () => state.form.accountIdsText,
      (val) => {
        state.form.accountIds = parseAccountIds(val)
      }
    )

    // 上传文件变化（只允许一个文件，校验格式/大小/像素）
    const MAX_SIZE = 5 * 1024 * 1024
    const ALLOWED_TYPES = ['image/bmp', 'image/jpeg', 'image/jpg', 'image/png']
    const checkImage = (file) => {
      return new Promise((resolve) => {
        const raw = file.raw || file
        // 类型校验
        const typeOk = ALLOWED_TYPES.includes(raw.type) || /\.(bmp|jpe?g|png)$/i.test(raw.name || '')
        if (!typeOk) {
          ElMessage.warning('只支持 bmp/jpeg/jpg/png 格式')
          return resolve(false)
        }
        // 大小校验
        if (raw.size > MAX_SIZE) {
          ElMessage.warning('图片大小不能超过 5M')
          return resolve(false)
        }
        // 像素校验
        const reader = new FileReader()
        reader.onload = (e) => {
          const img = new Image()
          img.onload = () => {
            if (img.width > 300 || img.height > 300) {
              ElMessage.warning('像素不能超过 300×300')
              resolve(false)
            } else {
              resolve(true)
            }
          }
          img.onerror = () => resolve(true)
          img.src = e.target.result
        }
        reader.onerror = () => resolve(true)
        reader.readAsDataURL(raw)
      })
    }

    const handleUploadChange = async (file, fileList) => {
      // 上传失败：同步清掉已选文件（el-upload 内部已移除该文件）
      if (file.status === 'fail') {
        state.form.fileList = fileList
        state.imageId = null
        state.uploadedFor = null
        return
      }
      // 只处理新选择（ready）的文件，上传成功等状态变化忽略
      if (file.status !== 'ready') return
      // 只保留最新一个
      const target = fileList[fileList.length - 1] || file
      const ok = await checkImage(target)
      if (!ok) {
        state.form.fileList = []
        uploadRef.value?.clearFiles()
        return
      }
      state.form.fileList = [target]
      // 换了图片，旧的 imageId 作废
      state.imageId = null
      state.uploadedFor = null
    }
    const handleUploadRemove = (file, fileList) => {
      state.form.fileList = fileList
      state.imageId = null
      state.uploadedFor = null
    }
    const handleExceed = () => {
      ElMessage.warning('只能上传一个图片')
    }

    // 点击开发者选择器时加载开发者列表（label 为备注，value 为 id，与 toutiaoManage 添加账户弹窗同接口）
    const loadDevOptions = (visible) => {
      if (!visible) return
      state.devOptionsLoading = true
      juliangDevList({})
        .then((res) => {
          state.devOptions = Array.isArray(res?.data) ? res.data : []
        })
        .catch(() => { })
        .finally(() => {
          state.devOptionsLoading = false
        })
    }

    // 取消
    const cancelFun = () => {
      emit('cancel')
    }

    // 结果弹窗关闭：全部成功时通知父级关闭上传弹窗
    const handleResultClose = () => {
      state.resultVisible = false
      if (state.resultAllSuccess) {
        emit('success')
      }
    }

    // 第二步：批量更新头像
    const updateAvatarFun = (imageId) => {
      state.submitting = true
      juliangDevUpdateAvatar({
        developerAccountId: state.form.developerAccountId,
        accountIds: state.form.accountIds,
        imageId,
      })
        .then((res) => {
          const data = res?.data || {}
          const items = Array.isArray(data.items) ? data.items : []
          state.resultItems = items.length
            ? items
            : [{ accountId: '—', success: true, message: res?.msg || '头像更新成功' }]
          state.resultSummary = {
            total: Number(data.total ?? state.resultItems.length),
            successCount: Number(data.successCount ?? state.resultItems.filter((it) => it.success).length),
            failCount: Number(data.failCount ?? state.resultItems.filter((it) => !it.success).length),
          }
          state.resultAllSuccess = items.length === 0 || items.every((it) => it.success)
          state.resultVisible = true
        })
        .finally(() => {
          state.submitting = false
        })
    }

    // 第一步：图片上传成功（el-upload 原生上传，走 uploadAction）
    const handleUploadSuccess = (response) => {
      if (!response || response.code != 200) {
        state.submitting = false
        ElMessage.error(response?.msg || '头像上传失败')
        return
      }
      // 取接口返回的 imageId（兼容 data 直接返回 id 的情况）
      const data = response.data
      const imageId = data && typeof data === 'object' ? (data.imageId ?? data.id) : data
      if (!imageId) {
        state.submitting = false
        ElMessage.error('上传返回数据缺少 imageId')
        return
      }
      state.imageId = imageId
      state.uploadedFor = { ...state.uploadData }
      updateAvatarFun(imageId)
    }

    const handleUploadError = () => {
      state.submitting = false
      ElMessage.error('图片上传失败，请重试')
    }

    // 确定：校验 -> 上传头像(取第一个账户) -> 批量更新头像
    const submitFun = async () => {
      // 同步一次最新解析结果，避免 watch 时序问题
      state.form.accountIds = parseAccountIds(state.form.accountIdsText)

      if (!state.form.developerAccountId) {
        ElMessage.warning('请选择开发者账户')
        return
      }
      if (!state.form.accountIds.length) {
        ElMessage.warning('请填写巨量账户')
        return
      }
      if (state.form.accountIds.length > 100) {
        ElMessage.warning('巨量账户最多 100 个')
        return
      }
      if (!state.form.fileList[0]?.raw) {
        ElMessage.warning('请上传图片')
        return
      }

      const accountId = state.form.accountIds[0]
      // 图片已上传且参数没变，直接更新头像；否则重新上传
      const canReuse =
        state.imageId &&
        state.uploadedFor &&
        state.uploadedFor.developerAccountId === state.form.developerAccountId &&
        state.uploadedFor.accountId === accountId
      if (canReuse) {
        updateAvatarFun(state.imageId)
        return
      }

      // 赋值上传参数，触发 el-upload 原生上传（multipart + authorize 头）
      state.uploadData = {
        developerAccountId: state.form.developerAccountId,
        accountId,
      }
      // 之前上传成功但参数变了需重新上传时，把文件状态重置为待上传
      const uploadFile = state.form.fileList[0]
      if (uploadFile.status === 'success') uploadFile.status = 'ready'
      state.submitting = true
      // 等待 uploadData 传到 el-upload 内部后再提交，否则上传时 data 还是旧值（缺 developerAccountId/accountId）
      await nextTick()
      uploadRef.value.submit()
    }

    return {
      // 结构赋值，暴露出去就不用 state.xx
      ...toRefs(state),
      uploadRef,
      loadDevOptions,
      handleUploadChange,
      handleUploadRemove,
      handleExceed,
      handleUploadSuccess,
      handleUploadError,
      submitFun,
      cancelFun,
      handleResultClose,
    }
  },
}
</script>

<style lang="scss" scoped></style>
